<template>
  <v-sheet>
    <p
      v-if="contentType === 'text'"
      class="body-1 mb-0"
      v-html="contentData"
    ></p>
    <v-divider v-if="contentType === 'divider'"></v-divider>
    <v-list v-if="contentType === 'list'" dense>
      <v-subheader
        v-if="contentTitle"
        class=""
        v-html="contentTitle"
      ></v-subheader>
      <v-list-item v-for="(line, index) in contentData" :key="index">
        <v-list-item-content class="py-0">
          <v-list-item-title class="body-2 text-wrap" v-html="line">
          </v-list-item-title>
          <!-- <v-list-item-subtitle>Test Case's section
                        </v-list-item-subtitle> -->
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-sheet>
</template>

<script lang="ts">
import Vue from "vue";
import { any } from "vue-types";

export default Vue.extend({
  name: "TopicConetnt",

  data() {
    return {};
  },
  props: {
    content: any()
  },
  computed: {
    contentData() {
      return this.content.data;
    },
    contentType() {
      return this.content.type;
    },
    contentTitle() {
      return this.content.title;
    },
  },
});
</script>
<style scoped>
.v-list--dense .v-list-item {
  min-height: 30px;
}
</style>
